import { ShieldCheck, Wrench } from "lucide-react";

const ROOF_IMG = "https://customer-assets-39nsmqrw.emergentagent.net/job_solar-ppa-qualify/artifacts/0f9pd9yo_image.png";

export default function RoofProtection() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="roof-protection-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="eyebrow">Your Protection</div>
          <h2 className="mt-3 font-serif-display text-3xl md:text-5xl font-semibold text-[#0F382C]">
            What about my roof?
          </h2>
          <p className="mt-4 text-lg text-slate-600 max-w-lg">
            "We cover what we touch."
            <span className="block mt-2 text-sm text-slate-500 italic">Every penetration and mount our crews install is backed by our written workmanship warranty — not a universal structural guarantee.</span>
          </p>

          <div className="mt-8 space-y-4">
            <div className="flex items-start gap-4 card-warm p-5">
              <div className="w-11 h-11 rounded-xl bg-[#0F382C] text-[#FEF3C7] flex items-center justify-center shrink-0">
                <ShieldCheck className="w-5 h-5" />
              </div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">10-Year Workmanship Warranty</div>
                <p className="text-sm text-slate-600 mt-1">Roof penetrations and workmanship are covered per the written warranty terms.</p>
              </div>
            </div>
            <div className="flex items-start gap-4 card-warm p-5">
              <div className="w-11 h-11 rounded-xl bg-[#D97706] text-[#FDFBF7] flex items-center justify-center shrink-0">
                <Wrench className="w-5 h-5" />
              </div>
              <div>
                <div className="font-serif-display text-lg text-[#0F382C]">Engineered Structural Attachment</div>
                <p className="text-sm text-slate-600 mt-1">Mounts are attached to structural roof members per engineering and installation requirements.</p>
              </div>
            </div>
          </div>

        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative rounded-[2rem] overflow-hidden border border-[#E5E0D8] shadow-xl" style={{ background: "linear-gradient(160deg, #E8F0EC 0%, #FEF3C7 100%)" }}>
            <img src={ROOF_IMG} alt="Jeremy pointing up at a rooftop solar installation on a Virginia home" className="w-full h-[380px] md:h-[560px] object-contain object-center" />
          </div>
        </div>
      </div>
    </section>
  );
}
